import { render, staticRenderFns } from "./AppSingleSelect.vue?vue&type=template&id=45b97ff8&scoped=true&"
import script from "./AppSingleSelect.vue?vue&type=script&lang=js&"
export * from "./AppSingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./AppSingleSelect.vue?vue&type=style&index=0&id=45b97ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b97ff8",
  null
  
)

export default component.exports